import {
  ENV_ENVIRONMENT,
  DEVELOPMENT,
  ENV_BACK_END_URL,  
  ENV_RECAPTCHA_SITE,
} from "./constants";

const ENVIRONMENT = process.env[ENV_ENVIRONMENT];

function isDevelopment() {
  return ENVIRONMENT === DEVELOPMENT;
}

const BACK_END_URL = process.env[ENV_BACK_END_URL] || "http://localhost:3000";
const RECAPTCHA_SITE = process.env[ENV_RECAPTCHA_SITE];


export { ENVIRONMENT, BACK_END_URL, RECAPTCHA_SITE, isDevelopment };
